// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6942999e","796":"0d051d02"}[chunkId] + ".chunk.js";
};